import { ref, type Ref } from 'vue';

/**
 * fastDateRangeRef — текущее «быстрое» окно, выставляется ТОЛЬКО при клике по чипсу,
 * очищается при выборе дат в календаре или при очистке чипса.
 */
let fastDateRangeRef: Ref<string | null> | undefined;

/**
 * lastAppliedFastDateRangeRef — последнее ПРИМЕНЁННОЕ «быстрое» окно (нужно для reset-события).
 * Обновляется на Apply, читается на Reset.
 */
let lastAppliedFastDateRangeRef: Ref<string | null> | undefined;

export function useFiltersDateRange() {
  if (!fastDateRangeRef) {
    fastDateRangeRef = ref<string | null>(null);
  }

  if (!lastAppliedFastDateRangeRef) {
    lastAppliedFastDateRangeRef = ref<string | null>(null);
  }

  return { fastDateRangeRef, lastAppliedFastDateRangeRef };
}
